import icons from '@/components/svg'

export default {
  colors: {
    primary: '#528ef7',
    secondary: '#101e3e',
    error: '#FF726D',
    accent: '#FF726D',
    'osg-gray': '#828282',
    'osg-black': '#2a2a2a',
    'osg-active': '#e7effe',
    'osg-active-border': '#e7effe',
    'osg-active-font': '#528ef7',
    'osg-active-icon': '#1f3261',
    'osg-active-text': '#1f3261',
    'osg-gray-text': '#4f4f4f',
    'osg-gray-2': '#474747',
    'osg-gray-3': '#fafafa',
    'osg-gray-4': '#9e9e9e',
    'osg-gray-5': '#f0f0f0',
    'osg-gray-6': '#adadad',
    'osg-gray-7': '#7a7a7a',
    'osg-gray-8': '#e0e0e0',
    'primary-blue': '#e4f0ff',
    'negative-number': '#EE555A',
    'osg-red': '#ffe6e5',
    'osg-blue-comment': '#e0f2ff',
    'osg-gray-comment': '#f4f5f7'
  },
  icons: {
    'osg-instagram': {
      component: icons.InstagramIcon
    },
    'osg-linkedin': {
      component: icons.LinkedInIcon
    },
    'osg-website': {
      component: icons.WebsiteIcon
    },
    'osg-error': {
      component: icons.ErrorIcon
    },
    'osg-email': {
      component: icons.EmailIcon
    },
    'osg-chat': {
      component: icons.ChatIcon
    },
    'osg-logo': {
      component: icons.MutuusIcon
    },
    'osg-empty-state': {
      component: icons.EmptyStateIcon
    },
    'osg-biometric-validation': {
      component: icons.BiometricValidationIcon
    },
    'osg-general-error': {
      component: icons.GeneralErrorIcon
    },
    'osg-documentation-complete': {
      component: icons.DocumentationCompleteIcon
    },
    'osg-documentation-incomplete': {
      component: icons.DocumentationIncompleteIcon
    },
    'osg-documentation-pending-to-complete': {
      component: icons.DocumentationPendingToCompleteIcon
    },
    'osg-invoiceable-to-false-icon': {
      component: icons.InvoiceableToFalseIcon
    },
    'osg-chat-primary': {
      component: icons.ChatIconPrimary
    },
    'osg-chat-disabled': {
      component: icons.ChatIconDisabled
    },
    'osg-chat-secondary': {
      component: icons.ChatIconSecondary
    },
    'osg-account-primary': {
      component: icons.AccountIcon
    },
    'osg-agreements-primary': {
      component: icons.AgreementsIcon
    },
    'osg-minus-grey': {
      component: icons.MinusGreyIcon
    },
    'osg-multiple-account': {
      component: icons.MultipleAccountIcon
    },
    'osg-fingerprint-validation': {
      component: icons.FingerPrintValidationIcon
    },
    'osg-message-circle': {
      component: icons.MessageCircleIcon
    },
    'osg-ai-analysis-icon': {
      component: icons.AiAnalisysIcon
    },
    'osg-upload-file-icon': {
      component: icons.UploadFileIcon
    },
    'osg-risk-icon': {
      component: icons.RiskIcon
    },
    'osg-arrow-right-icon': {
      component: icons.ArrowRightIcon
    }
  }
}
